export default __webpack_public_path__ + "static/automation-d0e838c38bf171fbf9507e60d0460cdc.png";